var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21H6C4.35 21 3 19.65 3 18V6C3 4.35 4.35 3 6 3H12C12.55 3 13 3.45 13 4C13 4.55 12.55 5 12 5H6C5.45 5 5 5.45 5 6V18C5 18.55 5.45 19 6 19H12C12.55 19 13 19.45 13 20C13 20.55 12.55 21 12 21ZM16.71 7.79C16.51 7.6 16.26 7.5 16 7.5C15.45 7.5 15 7.95 15 8.5C15 8.76 15.1 9.01 15.29 9.21L17.08 11H9.49C8.94 11 8.49 11.45 8.49 12C8.49 12.55 8.94 13 9.49 13H17.08L15.29 14.79C15.09 14.99 15 15.24 15 15.5C15 16.05 15.45 16.5 16 16.5C16.26 16.5 16.51 16.4 16.71 16.21C17.78 15.15 21 12 21 12C21 12 17.77 8.85 16.71 7.79Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitIcon);
export default __webpack_public_path__ + "static/media/exit_icon.b55ae01313270b1f8cfa2a5d241453be.svg";
export { ForwardRef as ReactComponent };